import httpClient from "./httpClient";

const END_POINT = "/api/statistics";
const listTimeSheetsByDate = (page, perPage) => httpClient.get(`${END_POINT}?page=${page}&per_page=${perPage}`);
export {
  listTimeSheetsByDate
};
